import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ApolloProvider } from '@apollo/client';
import GlobalProvider from 'contexts';
import { client } from 'services/apolloInit';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'services/reactQueryService';
import ErrorBoundary from 'components/pages/ErrorBoundary';

//ROOT COMPONENT
//graphql initialization
//application context initialization

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // <React.StrictMode>
    <ApolloProvider client={client}>
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools buttonPosition="bottom-left" />
            <BrowserRouter>
                {/* <GlobalProvider> */}
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
                {/* </GlobalProvider> */}
            </BrowserRouter>
        </QueryClientProvider>
    </ApolloProvider>,

    // </React.StrictMode>,
);
